import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export const queryBuilderApiKeyStore = {
  getOperator: (): QueryKeyConfig => ({
    queryKey: [`GET_OPERATOR`],
    route: `/QueryBuilder/QueryOperatorsGetAll`,
  }),
  entityFieldGetAll: (param: string): MutationKeyConfig => ({
    mutationKey: [`ENTITY_FIELD_GET_ALL`],
    route: `/QueryBuilder/ReportEntityFieldsGetAll?param=${param}`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getFieldData: (url: string, isEnabled = true): QueryKeyConfig => ({
    queryKey: [`GET_FIELD_DATA`],
    route: url,
    isEnabled: isEnabled,
  }),
  saveQuery: (): MutationKeyConfig => ({
    mutationKey: [`SAVE_QUERY`],
    route: `/QueryBuilder/SaveQuery`,
    action: 'POST',
  }),
  runQuery: (): MutationKeyConfig => ({
    mutationKey: [`RUN_QUERY`],
    route: `/QueryBuilder/RunQuery`,
    action: 'POST',
    disableSnackbar: true,
  }),
  excecuteReport: (): MutationKeyConfig => ({
    mutationKey: [`EXECUTE_QUERY`],
    route: `/QueryBuilder/ExecuteReport`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getAllReports: (): QueryKeyConfig => ({
    queryKey: [`GET_ALL_REPORT`],
    route: `/QueryBuilder/GetAllReports`,
  }),
  deleteReport: (reportId: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_FLOOR`, reportId],
    route: `/QueryBuilder/DeleteReport/?reportId=${reportId}`,
    action: 'DELETE',
  }),
  getQuery: (queryId?: any): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_BYID`, queryId],
    route: `/QueryBuilder/GetReportByID?reportId=${queryId}`,
    isEnabled: !!queryId,
  }),
  scheduleQuery: (): MutationKeyConfig => ({
    mutationKey: [`SCHEDULE_QUERY`],
    route: `/QueryBuilder/SaveQueryScheduler`,
    action: 'POST',
  }),
  getScheduleQuery: (reportID?: any): QueryKeyConfig => ({
    queryKey: [`GET_SCHEDULE_QUERY`, reportID],
    route: `/QueryBuilder/GetQuerySchedulerByID?reportid=${reportID}`,
    isEnabled: !!reportID,
  }),
};
